var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v(
                _vm._s(_vm.trans("vehicle_registration.vehicleRegistration")) +
                  "\n                    "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: "/vehicle-registration" } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(
                              _vm.trans(
                                "vehicle_registration.vehicle_registration"
                              )
                            ) +
                            "\n                                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                " +
                      _vm._s(
                        _vm.trans(
                          "vehicle_registration.vehicle_registration_details"
                        )
                      ) +
                      "\n                            "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/vehicle-registration/create")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-plus" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.trans(
                        "vehicle_registration.create_vehicle_registration"
                      )
                    )
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/vehicle-registration")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.trans(
                        "vehicle_registration.vehicle_registration_list"
                      )
                    )
                )
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h4", { staticClass: "card-title float-left mb-0" }, [
            _vm._v(
              _vm._s(
                _vm.trans("vehicle_registration.vehicle_registration_details")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c("div", { staticClass: "card" }, [
                      _vm.userRole != "user"
                        ? _c("div", { staticClass: "card-header" }, [
                            _c("h4", { staticClass: "card-title" }, [
                              _vm._v("Vehicle Registration Details")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleRegistration
                        ? _c("div", { staticClass: "card-body" }, [
                            _vm.userRole != "user"
                              ? _c("div", { staticClass: "row mb-4" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "user-details bg-light p-3 rounded"
                                      },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "list-group list-group-flush"
                                          },
                                          [
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "list-group-item d-flex justify-content-between align-items-center bg-transparent"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "tax_payer.tax_id"
                                                        )
                                                      ) + ":"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vehicleRegistration
                                                          .user.tax_id
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "list-group-item d-flex justify-content-between align-items-center bg-transparent"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans("user.name")
                                                      ) + ":"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vehicleRegistration
                                                          .user.name
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "list-group-item d-flex justify-content-between align-items-center bg-transparent"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans("user.email")
                                                      ) + ":"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vehicleRegistration
                                                          .user.email
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "list-group-item d-flex justify-content-between align-items-center bg-transparent"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans("user.phone")
                                                      ) + ":"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "strong",
                                                  { staticClass: "text-dark" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.vehicleRegistration
                                                          .user.phone
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._m(0),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "vehicle-info bg-white p-3 rounded border"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush"
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.product_type_id"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .product_type.name
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.vehicle_type_id"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .vehicle_type.name
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.vehicle_category_id"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .vehicle_category.name
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.sub_category_id"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .sub_category.name
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.make"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration.make
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.model"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration.model
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.year_of_manufacture"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .year_of_manufacture
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._m(1),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "identification-info bg-white p-3 rounded border"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush"
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.chasis_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .chasis_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.plate_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .plate_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.engine_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .engine_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.engine_capacity"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .engine_capacity
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.color"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration.color
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._m(2),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "owner-info bg-white p-3 rounded border"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush"
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.id_type"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .id_type
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.id_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .id_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.drivers_license_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .drivers_license_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.policy_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .policy_number
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "registration-details bg-white p-3 rounded border"
                                  },
                                  [
                                    _c(
                                      "ul",
                                      {
                                        staticClass:
                                          "list-group list-group-flush"
                                      },
                                      [
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.plate_number_state_code"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .plate_number_state_code
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.plate_number_lga_code"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .plate_number_lga_code
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.old_plate_number"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.vehicleRegistration
                                                    .old_plate_number
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "vehicle_registration.issue_date"
                                                    )
                                                  ) + ":"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("formatDate")(
                                                    _vm.vehicleRegistration
                                                      .issue_date
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "li",
                                          {
                                            staticClass:
                                              "list-group-item d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text-muted" },
                                              [_vm._v("Status:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                class:
                                                  "badge badge-" +
                                                  _vm.vehicleRegistration
                                                    .status_class
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                                    " +
                                                    _vm._s(
                                                      _vm.vehicleRegistration
                                                        .status_text
                                                    ) +
                                                    "\n                                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row mt-4" }, [
                              _c("div", { staticClass: "col-12 text-right" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mr-2 mb-2",
                                    on: { click: _vm.printMe }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-print mr-1"
                                    }),
                                    _vm._v(
                                      " Print\n                                                    "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "section-title mb-3" }, [
      _c("i", { staticClass: "fas fa-car mr-2 text-primary" }),
      _vm._v(
        "Vehicle Information\n                                                    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "section-title mb-3" }, [
      _c("i", { staticClass: "fas fa-barcode mr-2 text-primary" }),
      _vm._v(
        "Vehicle Identification\n                                                    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "section-title mb-3" }, [
      _c("i", { staticClass: "fas fa-user-tie mr-2 text-primary" }),
      _vm._v(
        "Owner Information\n                                                    "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "section-title mb-3" }, [
      _c("i", { staticClass: "fas fa-file-contract mr-2 text-primary" }),
      _vm._v(
        "Registration Details\n                                                    "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }